import { render, staticRenderFns } from "./ModifyTTL.vue?vue&type=template&id=18c0c786&scoped=true"
import script from "./ModifyTTL.vue?vue&type=script&lang=js"
export * from "./ModifyTTL.vue?vue&type=script&lang=js"
import style0 from "./ModifyTTL.vue?vue&type=style&index=0&id=18c0c786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c0c786",
  null
  
)

export default component.exports